module.exports = __webpack_public_path__ + "static/media/trial1.304ea35a.mp3";